import React, { ReactElement } from 'react'
import { Empty } from 'antd'


interface AuthProps {
    message: string
    description? : string
}

export default function Auth({message, description}: AuthProps): ReactElement {
    return (
        <div>
            <Empty description={
                <span>
                    {message}
                </span>
                }
            >
                {description}
            </Empty>
        </div>
    )
}
